import { useEffect } from "react";

const isTypingTarget = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  (target.isContentEditable || ["INPUT", "TEXTAREA"].includes(target.tagName));

// H (hold) peeks at the image without overlays, M toggles the context mask
export const useOverlayShortcuts = (
  setIsPeeking: (peeking: boolean) => void,
  toggleMask: () => void,
  enabled = true,
) => {
  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.metaKey || e.ctrlKey || e.altKey || isTypingTarget(e.target)) {
        return;
      }
      const key = e.key.toLowerCase();
      if (key === "h") setIsPeeking(true);
      if (key === "m" && !e.repeat) toggleMask();
    };
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() === "h") setIsPeeking(false);
    };
    const stopPeeking = () => setIsPeeking(false);

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    window.addEventListener("blur", stopPeeking);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      window.removeEventListener("blur", stopPeeking);
    };
  }, [setIsPeeking, toggleMask, enabled]);
};
